// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3hAMx","wrapperWithBanner":"styles_wrapperWithBanner__3_tWF","banner":"styles_banner__3wXrR","main":"styles_main__3sfN8"};